import React from "react";
import { ProgressTracker } from "@atlaskit/progress-tracker";
import DropdownMenu, { DropdownItemGroup, DropdownItem } from '@atlaskit/dropdown-menu';
import { Button } from "@atlassiansox/microscopekit";
var FinishStep = "finish";
var TutorialHeader = function (props) {
    var navStages = props.resources.map(function (resource) { return ({
        id: resource.id,
        label: resource.displayName,
        percentageComplete: resource.classifications.length > 0 ? 100 : 0,
        status: isFocusResource(props.focus) && props.focus.id === resource.id ? "current" : "visited",
        href: "#",
        onClick: function () { return props.onFocus(resource.id); },
    }); });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "Tutorial-servicename" },
            "Service Name: ",
            props.serviceName),
        React.createElement("div", { className: "Tutorial-header" },
            React.createElement("span", { className: "Tutorial-header-top" },
                React.createElement(ProgressTracker, { items: navStages.slice(0, navStages.length > 5 ? 5 : navStages.length), animated: true, spacing: (navStages.length <= 5 && "comfortable") || "cosy" })),
            props.resources.length > 5 && (React.createElement("span", { className: "Tutorial-header-bottom" },
                React.createElement(DropdownMenu, { trigger: "More resources", triggerType: "button" },
                    React.createElement(DropdownItemGroup, null, props.resources.slice(5, props.resources.length - 1).map(function (r) {
                        return React.createElement(DropdownItem, { onClick: function () { return props.onFocus(r.id); } }, r.displayName);
                    }))))),
            React.createElement("span", { className: "Tutorial-header-bottom" },
                React.createElement(Button, { onClick: function () { return props.onFocus('finish'); } }, "Finish & Download")))));
};
function isFocusResource(focus) {
    return focus === FinishStep;
}
export default TutorialHeader;
